const mixin = {
}

export default mixin
